export const defaultAlertName = 'alert1';

export const emailValidationMessage = 'Invalid email format';
export const emptyInputValidationMessage = 'Please enter a value';
export const emptyDatabasesValidationMessage = 'At least one database must be selected from options.';
export const incompatibleDatabasesValidationMessage =
  'The original Alert was created with a database that is not currently supported. If you wish to proceed with the migration, please select the Reaxys database from the Advanced content option.';
export const getDuplicateAlertNameValidationMessage = (alertName) =>
  `Alert with name "${alertName}" already exists, please choose another one`;

export const typeOfAlertCreateDialog = 'typeOfAlertCreateDialog';
export const typeOfAlertLoginDialog = 'typeOfAlertLoginDialog';

export const alertCreateDialogReducerKey = 'alertCreateDialogReducer';
export const alertCreateDialogMergeStateReducerType = 'alertCreateDialogMergeStateReducerType';
export const alertCreateDialogResetReducerType = 'alertCreateDialogResetReducerType';
export const alertCreateDialogMergeFormReducerType = 'alertCreateDialogMergeFormReducerType';
export const alertCreateDialogUpdateFormReducerType = 'alertCreateDialogUpdateFormReducerType';

export const FREQUENCY_WEEKLY = 'weekly';
export const FREQUENCY_BIWEEKLY = 'biweekly';
export const FREQUENCY_MONTHLY = 'monthly';

export const PROCESS_OPTION_ZERO_RESULTS = 'do_not_send_alerts_with_zero_results';
export const PROCESS_OPTION_TITLE_AND_BIBLIO = 'include_in_email_title_and_bibliographic_info';
export const PROCESS_OPTION_ABSTRACT = 'include_in_email_abstract';
export const PROCESS_OPTION_FULL_ABSTRACT = 'include_in_email_full_abstract';
export const PROCESS_OPTION_PARTIAL_ABSTRACT = 'include_in_email_partial_abstract';
export const PROCESS_OPTION_HIT_DETAILS = 'include_in_email_hit_details';

export const PROCESS_OPTIONS_TRACKING_MAP = {
  [PROCESS_OPTION_TITLE_AND_BIBLIO]: 'Advanced email Title',
  [PROCESS_OPTION_ABSTRACT]: 'Advanced email Abstract',
  [PROCESS_OPTION_FULL_ABSTRACT]: 'Full',
  [PROCESS_OPTION_PARTIAL_ABSTRACT]: 'Partial',
  [PROCESS_OPTION_HIT_DETAILS]: 'Advanced email hit details',
};

export const PROCESS_OPTIONS_TRACKING_HIERARCHY = [
  { value: PROCESS_OPTION_TITLE_AND_BIBLIO },
  { value: PROCESS_OPTION_ABSTRACT, children: [PROCESS_OPTION_FULL_ABSTRACT, PROCESS_OPTION_PARTIAL_ABSTRACT] },
  { value: PROCESS_OPTION_HIT_DETAILS },
];

export const editMode = 'edit';
export const migrateMode = 'migrate';

export const alertDialogModes = {
  create: 'create',
  modify: 'modify',
};
